import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Navigate } from 'react-router-dom';
import { 
  selectCurrentToken, 
  selectRefreshTokenExecuted,
  setCredentials,
  setRefreshTokenExecuted 
} from '../../Redux/features/auth/authSlice';
import { useRefreshTokenMutation } from '../../Redux/features/auth/authApiSlice';

export default function ProtectedRoute({ children, redirectTo = 'register' }) {
  const token = useSelector(selectCurrentToken);
  const refreshTokenExecuted = useSelector(selectRefreshTokenExecuted);
  const dispatch = useDispatch();
  const [refreshToken] = useRefreshTokenMutation();

  useEffect(() => {
    // Solo ejecutar refresh token si hay token y NO se ha ejecutado ya en esta sesión
    if (token && !refreshTokenExecuted) {
      const executeRefreshToken = async () => {
        try {
          // Marcar como ejecutado ANTES de hacer la llamada para evitar múltiples requests
          dispatch(setRefreshTokenExecuted(true));
          
          const result = await refreshToken().unwrap();
          dispatch(setCredentials({ token: result.token }));
        } catch (error) {
          console.error('Failed to refresh token:', error);
          // Si falla, resetear el flag para permitir reintento más tarde
          dispatch(setRefreshTokenExecuted(false));
        }
      };

      executeRefreshToken();
    }
  }, [token, refreshTokenExecuted, dispatch, refreshToken]);

  if (!token) {
    return <Navigate to={`/${redirectTo}`} replace />;
  }

  return children;
}
